import { combineReducers } from 'redux';

import formatInstitutionToState from '$utils/formatInstitutionToState';
import formatUserToState from '$utils/formatUserToState';
import formatUserCurrentSpaceToState from '$utils/formatUserCurrentSpaceToState';
import formatUserSpacesToState from '$utils/formatUserSpacesToState';

import {
  INITIALIZE_APP_STARTED,
  INITIALIZE_APP_SUCCESS,
  INITIALIZE_APP_FAILED,
  FETCH_INSTITUTION_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_ACCESS_TOKEN_STARTED,
  FETCH_ACCESS_TOKEN_SUCCESS,
  FETCH_ACCESS_TOKEN_FAILED,
  FETCH_USER_INFO_ON_SPACES_SUCCESS,
  CHANGE_CURRENT_SPACE,
} from './core.types';

const initialStatusState = {
  isLoading: true,
  error: null,
};

const initialInstitutionState = {
  general: {},
  name: '',
  keys: {},
};

const initialUserState = {};
const initialAccessTokensState = {};
const initialCurrentSpaceState = null;
const initialSpacesState = [];

const statusReducer = (state = initialStatusState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return {
        ...initialStatusState,
        isLoading: true,
      };
    case INITIALIZE_APP_SUCCESS:
      return {
        ...initialStatusState,
        isLoading: false,
      };
    case INITIALIZE_APP_FAILED:
      return {
        ...initialStatusState,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

const institutionReducer = (state = initialInstitutionState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return initialInstitutionState;
    case FETCH_INSTITUTION_SUCCESS:
      return formatInstitutionToState(action.payload);
    default:
      return state;
  }
};

const userReducer = (state = initialUserState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return initialUserState;
    case FETCH_CURRENT_USER_SUCCESS:
      return formatUserToState(action.payload.user);
    default:
      return state;
  }
};

const accessTokensReducer = (state = initialAccessTokensState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return initialAccessTokensState;
    case FETCH_ACCESS_TOKEN_STARTED:
      return {
        ...state,
        [action.payload.spaceId]: {
          ...state[action.payload.spaceId],
          isFetching: true,
        },
      };
    case FETCH_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        // Tokens expire every 24h, we will refresh after 23h just to be safe.
        [action.payload.spaceId]: {
          isFetching: false,
          token: action.payload.accessToken,
          expiry: Date.now() + 1000 * 3600 * 23,
        },
      };
    case FETCH_ACCESS_TOKEN_FAILED:
      return {
        ...state,
        [action.payload.spaceId]: {
          ...state[action.payload.spaceId],
          isFetching: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};

const currentSpaceReducer = (state = initialCurrentSpaceState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return initialCurrentSpaceState;
    case FETCH_USER_INFO_ON_SPACES_SUCCESS:
      return formatUserCurrentSpaceToState(action.payload);
    case CHANGE_CURRENT_SPACE:
      return action.payload.newSpace;
    default:
      return state;
  }
};

const spacesReducer = (state = initialSpacesState, action) => {
  switch (action.type) {
    case INITIALIZE_APP_STARTED:
      return initialSpacesState;
    case FETCH_USER_INFO_ON_SPACES_SUCCESS:
      return action.payload.userInfoOnSpaces.map((info) =>
        formatUserSpacesToState(info)
      );
    default:
      return state;
  }
};

export default combineReducers({
  status: statusReducer,
  institution: institutionReducer,
  accessTokens: accessTokensReducer,
  user: userReducer,
  currentSpace: currentSpaceReducer,
  spaces: spacesReducer,
});
